import React, { useState } from 'react';
import TabLayout from '../../components/tab-components/TabLayout';
import TabHeader from '../../components/tab-components/TabHeader';
import TabBody from '../../components/tab-components/TabBody';
import ResponseSets from './ResponseSets';
import CompanyField from './CompanyField';
import { dataSetsTabsList } from './utils';
import FormsSets from './formsSets/FormsSets';
import QuestionsSets from './questionSets/QuestionsSets';
import TopicsSets from './topics/TopicsSets';

const DataSets = () => {
  const [selectedTab, setSelectedTab] = useState(dataSetsTabsList[0]);
  return (
    <>
      <TabLayout>
        <TabHeader
          tabList={dataSetsTabsList}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
        <TabBody>
          {selectedTab.value === 'company_field' ? (
            <CompanyField />
          ) : selectedTab.value === 'forms_sets' ? (
            <FormsSets />
          ) : selectedTab.value === 'questions_sets' ? (
            <QuestionsSets />
          ) : selectedTab.value === 'topics_sets' ? (
            <TopicsSets />
          ) : (
            <ResponseSets />
          )}
        </TabBody>
      </TabLayout>
    </>
  );
};

export default DataSets;
